export default __webpack_public_path__ + "static/media/d2edb0767d894bd40220f40bfa9dc045.svg";